export class GroupedCheckboxChanged extends CustomEvent {
    /**
     * @param {HTMLInputElement} checkbox
     * @param {string} group
     */
    constructor(checkbox, group) {
        super('groupedcheckboxchanged');

        this.checkbox = checkbox;
        this.group = group;
    }
}
